import actionTypes from '../constants/action-types';

const defaultCallbacks = {
  resolve: Function.prototype,
  reject: Function.prototype,
};

const initializeBlock = (blockId, locale, htmlLocale, callbacks = defaultCallbacks) => ({
  type: actionTypes.INITIALIZE_BLOCK,
  payload: {
    blockId,
    locale,
    htmlLocale,
    callbacks,
  },
});

export default initializeBlock;
